<script>
import VSelect from 'vue-select';

export default {
  name: 'AppSelect',
  components: {
    VSelect
  },
  props: {
    options: [Array, Object],
    label: {
      type: String,
      default: 'name'
    }
  },
  data() {
    return { opensUp: false };
  },
  beforeDestroy() {
    this.stopPositioning();
  },
  methods: {
    async startPositioning() {
      await this.$nextTick();
      if (!this.$refs.select || !this.$refs.select.$refs.dropdownMenu) {
        return;
      }
      this.positionDropdown();
      const view = this.$el.ownerDocument.defaultView;
      view.addEventListener('resize', this.positionDropdown);
      view.addEventListener('scroll', this.positionDropdown, true);
    },
    stopPositioning() {
      const view = this.$el.ownerDocument.defaultView;
      view.removeEventListener('resize', this.positionDropdown);
      view.removeEventListener('scroll', this.positionDropdown, true);
      this.opensUp = false;
    },
    positionDropdown(event) {
      const select = this.$refs.select;
      const menu = select.$refs.dropdownMenu;
      if (!menu || (event && event.target === menu)) {
        return;
      }
      const view = this.$el.ownerDocument.defaultView;
      const toggle = select.$refs.toggle.getBoundingClientRect();
      let top = 0;
      let bottom = view.innerHeight;

      // Respect both the iframe viewport and ancestors that clip the menu.
      for (let parent = this.$el.parentElement; parent; parent = parent.parentElement) {
        if (/(hidden|clip|auto|scroll)/.test(view.getComputedStyle(parent).overflowY)) {
          const rect = parent.getBoundingClientRect();
          top = Math.max(top, rect.top + parent.clientTop);
          bottom = Math.min(bottom, rect.top + parent.clientTop + parent.clientHeight);
        }
      }

      const above = Math.max(0, toggle.top - top - 4);
      const below = Math.max(0, bottom - toggle.bottom - 4);
      const height = Math.min(200, menu.scrollHeight);
      this.opensUp = below < height && above > below;
      menu.style.maxHeight = `${Math.min(200, this.opensUp ? above : below)}px`;
    }
  }
};
</script>

<template>
  <!-- the label prop is to specify the key name when passing an array of objects-->
  <v-select
    ref="select"
    v-bind="$attrs"
    v-on="$listeners"
    :class="{ 'app-select--opens-up': opensUp }"
    :label="label"
    :options="options"
    :clearable="false"
    @open="startPositioning"
    @close="stopPositioning"
  >
    <template #open-indicator="{ attributes }">
      <ion-icon v-bind="attributes" name="chevron-down-outline" aria-hidden="true" />
    </template>
    <template #selected-option="option">
      <!-- Support larger options, ideally should be handled with pure css -->
      <span :class="{ large: option[label]?.length > 50 }">{{ option[label] }}</span>
    </template>
    <template #option="option">
      <span :class="{ selected: option.name === $attrs.value }">
        {{ option[label] }}
      </span>
    </template>
  </v-select>
</template>
